import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import styles from './Blog.module.scss'
import ArticlePreview from './components/ArticlePreview';
import Breadcrumb, { BreadcrumbLayer } from "../../components/Breadcrumb";
import { NAME_PROJECT, URL_BASE } from "../../settings/global";
import Button from "../../components/ripple/Button";
import Link from "next/link";
import Page, { Block } from "../../layouts/Content";
import PageHeading from "../../layouts/pages/PageHeading";
import { NAV_BLOG } from "../../settings/navigation";

function Blog({page, pages, articles, layoutDimensions}) {

    const [view, setView] = useState(null);

    useEffect(() => {
        const localBlog = JSON.parse(localStorage.getItem('blog') || `{}`);
        if (!!Object.keys(localBlog || {})?.length) setView(localBlog.view);
    }, []);

    const renderSettings = () => {
        const _setView = type => {
            let data = {view: type};
            const localBlog = JSON.parse(localStorage.getItem('blog') || `{}`);
            setView(type)
            localStorage.setItem('blog', JSON.stringify({...localBlog, ...data}));
        }

        return (
            <div className={styles.view}>
                <Button
                    aria-label='Show articles as blocks'
                    className={styles.view__button}
                    icon='far fa-square'
                    displayType={`text`}
                    onClick={() => _setView('block')}
                    visuals={{colorBasic: view === 'block' || !view ? [`var(--colorFontCommon)`] : [`var(--colorFontDisabled)`]}}
                />
                <Button
                    aria-label='Show articles as grid'
                    className={styles.view__button}
                    icon='fas fa-th'
                    displayType={`text`}
                    onClick={() => _setView('grid')}
                    visuals={{colorBasic: view === 'grid' ? [`var(--colorFontCommon)`] : [`var(--colorFontDisabled)`]}}
                />
                <Button
                    aria-label='Show articles as list'
                    className={styles.view__button}
                    icon='fas fa-list'
                    displayType={`text`}
                    onClick={() => _setView('list')}
                    visuals={{colorBasic: view === 'list' ? [`var(--colorFontCommon)`] : [`var(--colorFontDisabled)`]}}
                />
            </div>
        )
    };

    // because of mobile seo (won't wait until react life circle would wake up)
    const isNarrow = typeof window !== "undefined" ? layoutDimensions.width <= 570 : true;

    return (
        <Page>
            <Block>
                <Breadcrumb>
                    <BreadcrumbLayer link={URL_BASE + '/'} name='Home'/>
                    <BreadcrumbLayer name='Blog'/>
                </Breadcrumb>
            </Block>
            <Block>
                <PageHeading padding='0 0 30px' textAlign='center'>{NAME_PROJECT} blog</PageHeading>
                {
                    (!articles?.length) ?
                        <div className={styles.empty}>
                            <i className={`fas fa-exclamation-triangle ${styles.empty__icon}`} aria-hidden="true"/>
                            <h1 className={styles.empty__message}>
                                Currently nothing to show. Please, come back later!
                            </h1>
                        </div>
                        :
                        <div className={styles.layout} data-view={isNarrow ? 'block' : (view || 'block')}>
                            {!isNarrow && renderSettings()}
                            <div className={styles.layout__articles}>
                                {
                                    articles.map((article, index) => {
                                        return (
                                            <ArticlePreview
                                                article={article}
                                                view={view}
                                                key={index + (article.slug || article._id || article.title)}
                                            />
                                        )
                                    })
                                }
                            </div>
                            <div className={styles.pages}>
                                {
                                    !!pages?.length &&
                                    pages.map((_page, index) => (
                                        (<Link
                                            href={`${NAV_BLOG}/page/${_page}`}
                                            key={index}
                                            className={styles.pages__link}>

                                            <Button
                                                aria-label={`Go to page ${_page}`}
                                                tabIndex='-1'
                                                className={styles.pages__link__button}
                                                title={_page.toString()}
                                                displayType={parseFloat(page) === _page ? `contained` : `text`}
                                            />

                                        </Link>)
                                    ))
                                }
                            </div>
                        </div>
                }
            </Block>
        </Page>
    );
}

const mapStateToProps = state => ({
    layoutDimensions: state.UI.layoutDimensions,
})

export default connect(mapStateToProps)(Blog)